<style scoped>
.h-btn {
    min-width: 200px;
}

.no-href-dec {
    text-decoration: none;
    cursor: pointer;
}
.branch-select{
    min-width:200px
}
</style>
<template>
    <!-- Content -->
    <div class="content-wrapper">
        <div class="row mb-3">
            <div class="col-md-12">
                <div class="row">

                    <div class="col-12 d-flex justify-content-between">
                    <h3 class="font-weight-bold">Staffs Members</h3>
                    <button v-if="user.role > 1" type="button" 
                      @click="showStaffModal(0, staff)"  class="btn btn-primary me-2">Add Staff</button>
                </div>
        
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">

               <div class="card-body">
                    
                    <div class="row mb-3">
                        <div class="col-sm-6 col-md-3 col-12 stretch-card col-grid">
<input type="text" v-model="this.search_staff"
                                                class="form-control"
                                                placeholder="Search Chochote">
                        </div>
                        
                         <div class="col-sm-12 col-md-5 col-12 stretch-card col-grid"></div>
                         <div class="col-sm-8 col-md-4 col-12 stretch-card col-grid">
                        <div class="d-flex w-100">
                                            <input type="text" v-model="this.filter_branch"
                                                style="width: 100px !important;" class="form-control"
                                                placeholder="Filter">
                                            <select v-model="branch_from"  @change="filterBranches" class="form-select form-control">
                                                <option v-for="branch in branches" :key="branch.id" :value="branch.id">
                                                    {{ branch.name }}
                                                </option>
                                            </select>

                                        </div></div>
                    </div>
                  
                    <div class="row">
                        <div class="col-12">
                              <div v-if="loading" class="mt-1">
                                                <div class="text-center">
                                                    <div class="spinner-grow text-success" role="status"></div>
                                                    <div class="spinner-grow text-danger" role="status"></div>
                                                    <div class="spinner-grow text-warning" role="status"></div>
                                                </div>
                                            </div>
                            <div class="table-responsive">
                                
                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                             <th>No</th>
                                            <th> Avator</th>
                                            <th> User name </th>
                                            <th> Full name </th>
                                            <th> Phone no </th>
                                            <th> Role </th>
                                            <th> Branch </th>
                                            <th> Action </th>
                                        </tr>
                                    </thead>
                                    <tbody id="staff-list">

                                        <tr v-for="(staff, index) in paginatedStaffs" :key="staff.id"  id="staff_{{this.id}}">
                                             <td>{{ (currentPage - 1) * perPage + index + 1 }}</td>
                                            <td class="py-1">
                                                <img :src="$store.state.img_url + user.avator" alt="image">
                                            </td>
                                            <td> {{staff.username}} </td>
                                            <td> {{staff.fulname}}</td>
                                            <td>
                                                {{staff.phone1}}
                                            </td>
                                            <td>
                                                <label v-if="staff.role == 3" class="badge badge-danger">Super manager</label>
                                                <label v-if="staff.role == 2" class="badge badge-success">Branch manager</label>
                                                <label v-if="staff.role == 1" class="badge badge-info">Branch staff</label>
                                                <label v-if="staff.role == 4" class="badge badge-warning">Customer Care</label>
                                            </td>
                                            <td> {{staff.bname}}</td>
                                            <td>
                                                <!--button type="button" id="view-staff" class="btn btn-info btn-icon">
                                                    <i class="ti-eye">{{userInfo.user.role}}</i>
                                                </button-->
                                          
                                                <button v-if="user.role > 1 && staff.role != 3 && (user.id != staff.id)" type="button" @click="showStaffModal(1, staff)"
                                                    class="edit_btn btn btn-success btn-icon">
                                                    <i class="fa fa-edit"></i>
                                                </button>
                                                <button @click="deleteStaff(staff.id)" v-if="user.role > 1 && staff.role != 3 && (user.id != staff.id)" type="button" class="delete_btn btn btn-danger btn-icon">
                                                    <i class="fa fa-times"></i>
                                                </button>
                                            </td>
                                        </tr>
                                     
                                    </tbody>
                                </table>
                            </div>
                                                       <div class="pagination-wrapper">

  <button 
    @click="currentPage--"
    :disabled="currentPage === 1">
    Prev
  </button>

  <button
    v-for="page in totalPages"
    :key="page"
    @click="currentPage = page"
    :class="{ active: currentPage === page }">
    {{ page }}
  </button>

  <button
    @click="currentPage++"
    :disabled="currentPage === totalPages">
    Next
  </button>

</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- create Modal -->
<div class="modal fade mobile-full-width" id="createModal" tabindex="-1" data-bs-backdrop="static"
    data-bs-keyboard="false" role="dialog" aria-labelledby="createModal" aria-hidden="true">
    <div class="modal-dialog modal-md" role="document">

        <div class="modal-content">
            <div class="modal-header">
                <h4 class="font-weight-bold">{{ form_label }}</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                </button>
            </div>
            <div class="container mt-3 mb-3">
                <form id="create-staff-form">
                    <div class="create-post-body">
                        <div v-if="loading_create" class="mt-1">
                                                <div class="text-center">
                                                    <div class="spinner-grow text-success" role="status"></div>
                                                    <div class="spinner-grow text-danger" role="status"></div>
                                                    <div class="spinner-grow text-warning" role="status"></div>
                                                </div>
                                            </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-12">
                                <div class="row">
                                    <div class="col-sm-6 col-md-6">
                                        <div class="form-group">
                                            <label class="form-label">Full name *</label>
                                            <input v-model="staff.fulname" class="form-control" maxlength="50"
                                                required type="text" placeholder="fullname">
                                        </div>


                                    </div>
                                    <div v-if="staff.id == 0" class="col-sm-6 col-md-6">
                                        <div class="form-group">
                                            <label class="form-label">Username *</label>
                                            <input v-model="staff.username" class="form-control" maxlength="20"
                                                required type="text" placeholder="username">
                                        </div>
                                    </div>
                                    <div class="col-sm-6 col-md-6">
                                        <div class="form-group">
                                            <label class="form-label">Phone1 *</label>
                                            <input v-model="staff.phone1" class="form-control" maxlength="20"
                                                required type="text" placeholder="0xxxxxxxxx">
                                        </div>
                                    </div>
                                    <div class="col-sm-6 col-md-6">
                                        <div class="form-group">
                                            <label class="form-label">Phone2 </label>
                                            <input v-model="staff.phone2" class="form-control" maxlength="20"
                                                type="text" placeholder="0xxxxxxxxx">
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-12">
                                        <div class="form-group">
                                            <label class="">Branch *</label>
                                             <div class="d-flex">
                                            <input type="text" v-model="branch_form_filter" style="width: 120px !important;" class="form-control" placeholder="search" onkeyup="filter1()">
                                            <select v-model="staff.branch_id"
                                                class="form-select form-control">
                                               
                                                <option v-for="branch in branches" :key="branch.id" :value="branch.id">{{branch.name}}</option>
                                              
                                            </select>
                                            </div>
                                            
                                        </div>
                                    </div>

                                    <div class="col-sm-6 col-md-6">

                                        <div class="form-group">
                                            <label class="">Role *</label>
                                            <select v-model="staff.role" class="form-select form-control">
                                                <option value="1">Branch staff</option>
                                                <option value="4">Customer Care</option>
                                                <option v-if="user.role == 3" value="2">Branch manager</option>
                                                <option v-if="user.role == 3" value="3">Super manager</option> 
                                            </select>
                                        </div>
                                    </div>

                                     <div class="col-sm-6 col-md-6">
                                        <div class="form-group">
                                            <label class="form-label">User Status *</label>
                                            <select v-model="staff.status"
                                                class="form-select form-control">
                                                <option value="1">Active</option>
                                                <option value="0">Inactive</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div v-if="staff.id == 0" class="col-sm-12 col-md-12">
                                        <div class="alert alert-info">
                                            <p>Once staff is created account is active, can login by username and phone1
                                                as password (must change password once loged)</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="create-post-bottom">
                        <button class="btn btn-primary" @click="createUpdated" type="button" id="submit-create-staff">{{ form_label }}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

</template>
<script>
import axios from "axios";

import PriceFormat from "@/components/PriceFormat.vue";
import PhoneFormat from "@/components/PhoneFormat.vue";
import DateFormat from "@/components/DateFormat.vue";


export default {
    components: {
        PriceFormat,
        PhoneFormat,
        DateFormat,

    },
    data() {
        return {
            loading: false,
            loading_create:false,
            filter_branch:"",
            branch_form_filter:"",
            search_staff:"",
            branches: [],
            og_branches: [],
            form_branches: [],
            og_form_branches: [],
            branch_from:0,
            staffs:[],
            og_staffs:[],
            staff: {
                fulname: '',
                username: '',
                id: 0,
                role: 1,
                branch_id: 0,
                status: 1,
                phone1: '',
                phone2: '',
            },
            form_label:"Create Staff",
            currentPage: 1,
            perPage: 20,
            user: this.$attrs.user
        };
    },
    methods: {

        async getAllBranch() {

            var response = await axios
                .get(this.$store.state.api_url + "/branch/all-branches")
                .catch((errors) => {
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {

                this.branches = [ { id: 0, name: "All Branches" },...response.data.branches];
                this.og_branches = [ { id: 0, name: "All Branches" },...response.data.branches];

                this.form_branches = response.data.branches
                this.og_form_branches = response.data.branches


            } else {
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

               async createUpdated() {

            var staff = this.staff

            var route_ = "/update-staff"

            if(staff.id == 0){
                route_ = "/create-staff"
            }
           

            var response = await axios
                .post(this.$store.state.api_url + route_, staff)
                .catch((errors) => {
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {

                window.location.reload();
               
            } else {
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

                    async deleteStaff(id) {

            var staff_id = id
            //var branches = this.branches
            //var og_branches = this.og_branches

            var response = await axios
                .post(this.$store.state.api_url + "/delete-staff",{staff_id})
                .catch((errors) => {
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {

                 var message = response.data.message;
                this.$toast.success(message, { duration: 5000, dismissible: true });

               this.staffs = this.staffs.filter(item => item.id !== staff_id);
               this.og_staffs = this.og_staffs.filter(item => item.id !== staff_id);

            } else {
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

        filterBranches() {
        const id = Number(this.branch_from);

        if (id === 0) {
            // Show all branches
            this.staffs = [...this.og_staffs];
        } else {
            // Show only selected branch
            this.staffs = this.og_staffs.filter(
                staff => Number(staff.branch_id) === id
            );
        }
    },

        showStaffModal(type, staff){

            var b_id = this.user.branch_id

            if(type == 0){
                this.staff = {
                fulname: '',
                username: '',
                id: 0,
                role: 1,
                branch_id: b_id,
                status: 1,
                phone1: '',
                phone2: '',
            }

            this.form_label = "Create Staff"
            }else{
                this.staff = staff
                this.form_label = "Update Staff"
            }

            const modal = bootstrap.Modal.getOrCreateInstance(
                document.getElementById("createModal")
            );

            modal.show();
        },

        async getStaffs() {

            this.loading = true

            var response = await axios
                .get(this.$store.state.api_url + "/staff/all-staffs")
                .catch((errors) => {
                    this.loading = false
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {
                this.loading = false
                this.staffs = response.data.staffs;
                this.og_staffs = response.data.staffs

               /// console.log(this.parcels)

            } else {
                this.loading = false
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

         nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++
    }
  },

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--
    }
  },

    },
      computed: {

  paginatedStaffs() {
    const start = (this.currentPage - 1) * this.perPage
    const end = start + this.perPage

    return this.staffs.slice(start, end)
  },

  totalPages() {
    return Math.ceil(this.staffs.length / this.perPage)
  },
  

},
    watch: {

        filter_branch(value) {

            let term = value.toLowerCase().trim()

            if (!term) {
                this.branches = this.og_branches
                return
            }

            this.branches = this.og_branches.filter(branch => {

                return (
                    (branch.name && branch.name.toLowerCase().includes(term)) ||
                    (branch.region && branch.region.toLowerCase().includes(term))
                )
            })
        },

          branch_form_filter(value) {

            let term = value.toLowerCase().trim()

            if (!term) {
                this.form_branches = this.og_form_branches
                return
            }

            this.form_branches = this.og_form_branches.filter(branch => {

                return (
                    (branch.name && branch.name.toLowerCase().includes(term)) ||
                    (branch.region && branch.region.toLowerCase().includes(term))
                )
            })
        },

        search_staff(value) {

            let term = value.toLowerCase().trim()

            if (!term) {
                this.staffs = this.og_staffs
                return
            }

            this.staffs = this.og_staffs.filter(staff => {

                return (
                    (staff.bname && staff.bname.toLowerCase().includes(term)) ||
                    (staff.bregion && staff.bregion.toLowerCase().includes(term)) ||
                    (staff.username && staff.username.toLowerCase().includes(term)) ||
                    (staff.fulname && staff.fulname.toLowerCase().includes(term)) ||
                    (staff.phone1 && staff.phone1.toLowerCase().includes(term))
                )
            })
        }
 
    },
    created() {
        this.$store.state.page_name = "Dashbord"
        this.getAllBranch()
        this.getStaffs()
    },
    mounted() {
        //$('#dashbord').attr('class', 'nav-item active');
    }
};
</script>
